<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column
            h3.is-size-3 
              | Agregar Consumible
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column
            input#noCheckBD.is-checkradio.is-black(type='radio', value='NEW' v-model='checkInBD')
            label.is-size-6(for='noCheckBD') Nuevo
            input#checkBD.is-checkradio.is-black(type='radio', value='BD' v-model='checkInBD')
            label.is-size-6(for='checkBD') A partir de Consumible en la Base de Datos.
        .columns(v-show="verFormBD")
          .column.is-5
            Typeahead(:options="consumibles" :optionSelect="consumibleBD" :tema="typeTipos" v-model="consumibleBD")
        .columns(v-show="verFormNew")
          FormCons_Entrada(:marcas="marcas" :tipos="tipos" @saveForm="saveForm")
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'
  
  import FormCons_Entrada from './FormCons_Entrada.vue'
  import moment from 'moment'
  import { mapState } from 'vuex'
  
  

  export default {
    name: 'NuevoConsumible',
    components: { Loader, NavBarInventario, FormCons_Entrada, Typeahead },
    data() {
      return {
        isLoading: true,
        isDisabled: false,
        isEditing: false,
        isSaved: false,
        isLoading: true,
        tipos: [],
        marcas: [],
        consumibles: [],
        consumibleBD: {},
        checkInBD: '',
        verFormNew: false,
        verFormBD: false,
        typeTipos: 'tipos',
      }
    },
    watch: {
      checkInBD() {
        if (this.checkInBD === 'NEW') {
          this.verFormNew = true
          this.verFormBD = false
          this.consumibleBD = {}
        } else {
          this.verFormNew = false
          this.verFormBD = true
        }
      },
      consumibleBD () {
        if (Object.keys(this.consumibleBD).length > 0) {
          this.irConsumibleDetalle(this.consumibleBD)
        }
      }
    },
    
    methods: {
      obtenerTipos () {
        InventarioServices.getCats_Subcats()
          .then(res => {
            if (res.length > 0) {
                
              res.forEach(element => {
                let tipoObj = {}
                if (parseInt(element.isConsumible) == 1) {
                  if (element.subcategoria === '') {
                    tipoObj = {
                      id: element.id,
                      text: `${element.categoria}`,
                      id_cat: element.id, 
                      categoria: `${element.categoria}`,
                      id_sub: element.id_sub,
                      subcategoria: '',
                      isConsumible: `${element.isConsumible}`,
                      area: `${element.area}`
                    }
                  } else {
                    tipoObj = {
                      id: element.id,
                      text: `${element.categoria} - ${element.subcategoria}`,
                      id_cat: element.id, 
                      categoria: `${element.categoria}`,
                      id_sub: element.id_sub,
                      subcategoria: `${element.subcategoria}`,
                      isConsumible: `${element.isConsumible}`,
                      area: `${element.area}`
                    }
                  }
                  this.tipos.push(tipoObj)
                }

              })
            }
          })
        this.obtenerMarcas()
      },
      
      obtenerMarcas () {
        InventarioServices.getMarcas()
          .then(res => {
            if (res.data.length > 0) {
                
              res.data.forEach(element => {
                let marcaObj = {}
                  marcaObj = {
                    id: element.id,
                    text: element.nombre,
                    nombre: element.nombre
                  }
                this.marcas.push(marcaObj)
              });
            }
            this.obtnerConsumiblesBD()
          })
      },

      obtnerConsumiblesBD () {
        this.consumibles = []
        InventarioServices.getBaseConsumibles()
          .then((data) => {
            if (data.length > 0) {

              data.map((cons) => {
                let myObj = {
                  id: cons.id,
                  id_cat: cons.id_cat,
                  categoria: cons.categoria,
                  id_subcat: cons.id_subcat,
                  subcategoria: cons.subcategoria,
                  marca: cons.marca,
                  modelo: cons.modelo,
                  limite: cons.limite,
                  text: `${cons.categoria} ${cons.subcategoria} - ${cons.marca} ${cons.modelo}`
                }
                this.consumibles.push(myObj)
              })

            }
          })
          .catch((e) => console.log(e))
        this.isLoading = false
      },
      saveForm (form) {
        console.log(form)
        this.isLoading = true
        InventarioServices.addConsumible(form.marca,form.modelo, form.area, form.linea, form.detalle, 
        form.id_cat,form.categoria,form.id_subcat,form.subcategoria,form.unidadMedida, form.limite, form.noParte)
          .then( res => {
            console.log(res)
            if (res.success) {
              this.displayToast('Se ha registrado la entrada del consumible.', 'done', 'Ok')
              this.verFormBD = false
              this.verFormNew = false
              this.obtnerConsumiblesBD()
            } else {
              console.log(res.respuesta)
            }
          })
      },
      
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      irConsumibleDetalle(consumible) {
        console.log(consumible)
        this.$store.commit('selectConsumible', consumible)
        this.$router.push('/Inventario/Consumibles/Detalle')
      },
    backPage () {
      this.$router.back()
    }, 

    },
    created () {
      this.idIngresa = this.userLogin.id
      this.ingresa = this.userLogin.nombre
      this.idResguardo = this.userLogin.id
      this.resguardo = this.userLogin.nombre
      this.obtenerTipos()
    },
    computed: {
      ...mapState(['userLogin'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/NuevoConsumible.vue